import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import PortfolioInfo from '../pages/portfolio/show/info';
import PortfolioProjects from '../pages/portfolio/show/projects';
import PortfolioSettings from '../pages/portfolio/settings';
import PortfolioNewStepGeneral from '../pages/portfolio/new/step-general';
import PortfolioNewStepDetails from '../pages/portfolio/new/step-details';
import PortfolioNewStepMilestones from '../pages/portfolio/new/step-milestones';
import PortfolioNewStepLinkedFiles from '../pages/portfolio/new/step-linked-files';
import PortfolioEditStepGeneral from '../pages/portfolio/edit/step-general';
import PortfolioEditStepDetails from '../pages/portfolio/edit/step-details';
import PortfolioEditStepMilestones from '../pages/portfolio/edit/step-milestones';
import PortfolioEditStepLinkedFiles from '../pages/portfolio/edit/step-linked-files';
import ParentPortfolioNew from '../pages/parent-portfolio/new';
import ParentPortfolioEdit from '../pages/parent-portfolio/edit';

export const portfolioRoutes = () => (
  <>
    {/* Parent Portfolio Routes */}
    <Route
      path={ROUTES.PARENT_PORTFOLIO_NEW}
      element={<ParentPortfolioNew />}
    />
    <Route
      path={ROUTES.PARENT_PORTFOLIO_EDIT}
      element={<ParentPortfolioEdit />}
    />

    {/* Portfolio Routes */}
    <Route path={ROUTES.PORTFOLIO_INFO} element={<PortfolioInfo />} />
    <Route path={ROUTES.PORTFOLIO_PROJECTS} element={<PortfolioProjects />} />
    <Route path={ROUTES.PORTFOLIO_SETTINGS} element={<PortfolioSettings />} />

    {/* Portfolio New Steps */}
    <Route
      path={ROUTES.PORTFOLIO_NEW_STEP_GENERAL}
      element={<PortfolioNewStepGeneral />}
    />
    <Route
      path={ROUTES.PORTFOLIO_NEW_STEP_DETAILS}
      element={<PortfolioNewStepDetails />}
    />
    <Route
      path={ROUTES.PORTFOLIO_NEW_STEP_MILESTONES}
      element={<PortfolioNewStepMilestones />}
    />
    <Route
      path={ROUTES.PORTFOLIO_NEW_STEP_LINKED_FILES}
      element={<PortfolioNewStepLinkedFiles />}
    />

    {/* Portfolio Edit Steps */}
    <Route
      path={ROUTES.PORTFOLIO_EDIT_STEP_GENERAL}
      element={<PortfolioEditStepGeneral />}
    />
    <Route
      path={ROUTES.PORTFOLIO_EDIT_STEP_DETAILS}
      element={<PortfolioEditStepDetails />}
    />
    <Route
      path={ROUTES.PORTFOLIO_EDIT_STEP_MILESTONES}
      element={<PortfolioEditStepMilestones />}
    />
    <Route
      path={ROUTES.PORTFOLIO_EDIT_STEP_LINKED_FILES}
      element={<PortfolioEditStepLinkedFiles />}
    />
  </>
);
